<script>
  import {sgettext} from '../../i18n.js';

  $: blurb = sgettext("$$ISSUES_RAISED_TECHNICIAN_SUPERVISOR_SITE$$")
</script>

<div class="issue-blurb">
  <div class="issue-blurb--content">
    <svg
      fill="#000000"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width="40px"
      height="40px"
      ><path
        d="M 16 3 C 8.832031 3 3 8.832031 3 16 C 3 23.167969 8.832031 29 16 29 C 23.167969 29 29 23.167969 29 16 C 29 8.832031 23.167969 3 16 3 Z M 16 5 C 22.085938 5 27 9.914063 27 16 C 27 22.085938 22.085938 27 16 27 C 9.914063 27 5 22.085938 5 16 C 5 9.914063 9.914063 5 16 5 Z M 15 10 L 15 12 L 17 12 L 17 10 Z M 15 14 L 15 22 L 17 22 L 17 14 Z"
      /></svg
    >
    <p>{blurb}</p>
  </div>
</div>

<style>
  .issue-blurb {
    display: flex;
    justify-content: center;
    padding-top: 10px;
  }

  .issue-blurb--content {
    display: flex;
    align-items: center;
    max-width: 800px;
    padding: 16px;
    border-radius: 10px;
    border: 2px solid #0099cc;
  }

  .issue-blurb--content p {
    margin: 0;
    padding-left: 16px;
  }

  .issue-blurb--content svg path {
    fill: #0099cc;
  }
</style>
